import React from "react";
import { Grid } from "semantic-ui-react";
const Videos = () => {
  return (
    <div className="videos">
      <h1>Teaser Videos</h1>
      <div className="teaser">
        <div className="teaser1">
          <iframe
            width="500"
            height="315"
            src="https://www.youtube.com/embed/6-kZmn54vOs"
            title="YouTube video player"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          ></iframe>
          <h3>Twice "Alcohol-Free" M/V Teaser 1</h3>
          <p>June 06, 2021</p>
        </div>
        <div className="teaser2">
          <iframe
            width="500"
            height="315"
            src="https://www.youtube.com/embed/ZGIY1agr3gg"
            title="YouTube video player"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          ></iframe>
          <h3>Twice "Alcohol-Free" M/V Teaser 2</h3>
          <p>June 07, 2021</p>
        </div>
      </div>
    </div>
  );
};

export default Videos;
